<template>
    <div v-if="show" class="app-upgrade-strip-wrap">
        <div class="app-upgrade-strip-spacer"></div>
        <div ref="strip" class="app-upgrade-strip">
            <span class="_text">Your Free Account is browse-only. Ready to connect with a NannyGranny?</span>
            <v-btn to="/subscription"
                   :class="['ma-0 elevation-0 _btn', {'upgrade-pulse': pulsing}]">
                Get Full Access{{ price ? ` — $${price}` : '' }}
            </v-btn>
        </div>
    </div>
</template>

<script>
  import { DEFAULT_SIGNUP_OPT } from '../config/constants'
  import upgradePulseMixin from '../mixins/upgrade-pulse'

  // Sticky bottom strip shown to logged-in Free Customers across the site
  export default {
    name: 'app-upgrade-strip',

    mixins: [upgradePulseMixin],

    computed: {
      show () {
        if (!this.$auth.check()) return false
        const user = this.$auth.user()
        const isFreeCustomer = user.role === 'parent' && user.subscription && user.subscription.ended
        return Boolean(isFreeCustomer) && !/^\/(subscription|signup)/.test(this.$route.path)
      },
      price () {
        const plan = this.$store.getters['subscription/plans'].find(item => item.id === DEFAULT_SIGNUP_OPT[0])
        return plan ? Math.round(plan.price) : null
      }
    },

    watch: {
      // Lets global styles lift bottom snackbars above the strip
      show: {
        immediate: true,
        handler (val) {
          document.body.classList.toggle('has-upgrade-strip', val)
          this.$nextTick(this.updateHeight)
        }
      }
    },

    mounted () {
      window.addEventListener('resize', this.updateHeight)
    },

    beforeDestroy () {
      window.removeEventListener('resize', this.updateHeight)
      document.body.classList.remove('has-upgrade-strip')
    },

    methods: {
      // Strip wraps on narrow screens, so publish its real height for the spacer and snackbars
      updateHeight () {
        if (this.$refs.strip) {
          document.body.style.setProperty('--upgrade-strip-height', this.$refs.strip.offsetHeight + 'px')
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
    .app-upgrade-strip-spacer
        height var(--upgrade-strip-height, 64px)
    .app-upgrade-strip
        position fixed
        left 0
        right 0
        bottom 0
        z-index 100
        display flex
        align-items center
        justify-content center
        flex-wrap wrap
        gap 8px 20px
        min-height 64px
        padding 10px 16px calc(10px + env(safe-area-inset-bottom, 0px))
        background var(--orange)
        color #fff
        text-align center
        ._text
            font-size 16px
            font-weight bold
        ._btn
            height auto !important
            padding 8px 20px !important
            background #fff !important
            color var(--orange) !important
            font-weight bold
    @media (max-width: 600px)
        .app-upgrade-strip
            ._text
                font-size 14px
</style>



// WEBPACK FOOTER //
// src/components/app-upgrade-strip.vue